import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_LEGALITYDOCUMENT,
  DELETE_LEGALITYDOCUMENT,
  UPDATE_LEGALITYDOCUMENT,
  ADD_NEW_LEGALITYDOCUMENT,
} from "./actionType";

import {
  getLegalityDocumentSuccess,
  getLegalityDocumentFail,
  deleteLegalityDocumentSuccess,
  deleteLegalityDocumentFail,
  updateLegalityDocumentSuccess,
  updateLegalityDocumentFail,
  addLegalityDocumentSuccess,
  addLegalityDocumentFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getLegalityDocumentApi,
  updateLegalityDocumentApi,
  deleteLegalityDocumentApi,
  addNewLegalityDocumentApi
} from "../../helpers/backend_helper";

function* getLegalityDocument({ payload: legalityDocument }) {
  try {
    const response = yield call(getLegalityDocumentApi, legalityDocument);
    yield put(getLegalityDocumentSuccess(GET_LEGALITYDOCUMENT, response.data));
  } catch (error) {
    yield put(getLegalityDocumentFail(GET_LEGALITYDOCUMENT, error));
  }
}

function* onUpdateLegalityDocument({ payload: legalityDocument }) {
  try {
    const response = yield call(updateLegalityDocumentApi, legalityDocument);
    yield put(updateLegalityDocumentSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateLegalityDocumentFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteLegalityDocument({ payload: legalityDocument }) {
  try {
    const response = yield call(deleteLegalityDocumentApi, legalityDocument);
    yield put(deleteLegalityDocumentSuccess({ legalityDocument, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteLegalityDocumentFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewLegalityDocument({ payload: legalityDocument }) {
  try {
    const response = yield call(addNewLegalityDocumentApi, legalityDocument);
    yield put(addLegalityDocumentSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addLegalityDocumentFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetLegalityDocument() {
  yield takeEvery(GET_LEGALITYDOCUMENT, getLegalityDocument);
}

export function* watchUpdateLegalityDocument() {
  yield takeEvery(UPDATE_LEGALITYDOCUMENT, onUpdateLegalityDocument);
}

export function* watchDeleteLegalityDocument() {
  yield takeEvery(DELETE_LEGALITYDOCUMENT, onDeleteLegalityDocument);
}

export function* watchAddNewLegalityDocument() {
  yield takeEvery(ADD_NEW_LEGALITYDOCUMENT, onAddNewLegalityDocument);
}

function* legalityDocumentSaga() {
  yield all([
    fork(watchGetLegalityDocument),
    fork(watchDeleteLegalityDocument),
    fork(watchUpdateLegalityDocument),
    fork(watchAddNewLegalityDocument)
  ]);
}

export default legalityDocumentSaga;
